import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Accordion, AccordionDetails, Box, Grid, CircularProgress, Backdrop } from "@mui/material";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import AddTitleToBroswerTab from "src/components/molecules/AddTitleToBroswerTab";
import NoRecordFound from "src/components/NoRecordFound";
import { Card } from "./Card";
import Heading from "./Heading";
import { useStyles } from "./styles";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export function OrderInfo({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [orderInfo, setOrderInfo] = useState<any>({});
  const { id } = useParams<{ id: any }>();

  const getOrderInfoData = async () => {
    try {
      setLoader(true);
      const results = await fetchWrapper.get(`get-order-detail-by-ocd-id/${id}`);
      setOrderInfo(results);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  React.useEffect(() => {
    if (expand) {
      getOrderInfoData();
    }
  }, [expand]);
  const pageTitle = `TFG | Portal | WO:${orderInfo && orderInfo?.ordNum} : ${
    orderInfo && orderInfo?.clientCode
  }`;
  return (
    <>
      <AddTitleToBroswerTab title={pageTitle} />
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(0)}>
          <Heading heading="Work Order information" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Grid container direction="row">
              <Grid xs={12} md={12}>
                {Boolean(Object.keys(orderInfo).length) ? (
                  <Card orderInfoData={orderInfo} />
                ) : (
                  <NoRecordFound />
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}
